import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import Home from './pages/Home';
import Home2 from './pages/Home2';
import CSVQueryTool from './pages/CSVQueryTool';
import PKUPathway from './pages/pkupathway';
import RareDisease from './pages/rare_disease';
import RareScale from './pages/RareScale';
import PDEPathway from './pages/pdepathway';
import PDEPathway2 from './pages/PDEPathway2';
import PDEPathway3 from './pages/PDEPathway3';
import EpilepsyJourney from './pages/EpilepsyJourney';
import ZolgensmaChoice from './pages/ZolgensmaChoice';
import RareScaleEducational from './pages/RareScaleEducational';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Home2 />} />
        <Route path="/tools/csv_query" element={<CSVQueryTool />} />
        <Route path="/raredisease/pde" element={<PDEPathway3 />} />
        {/* <Route path="/raredisease/pku" element={<PKUPathway />} />
        <Route path="/raredisease/pde2" element={<PDEPathway2 />} />
        <Route path="/raredisease/pde" element={<PDEPathway />} />
        <Route path="/raredisease/rare_disease" element={<RareDisease />} />
        <Route path="/raredisease/rarescale" element={<RareScale />} /> */}
        <Route path="/raredisease/overview" element={<RareScaleEducational />} />
        {/* <Route path="/raredisease/epilepsy" element={<EpilepsyJourney />} />
        <Route path="/raredisease/zolgensma" element={<ZolgensmaChoice />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
